import React from 'react';
import styled from 'styled-components';

import { SectionSidePadding } from '../Common';
import { SectionHeading } from '../Common/Headings';
import { Summary, Props as SummaryProps } from './Summary';
import { Review, Props as ReviewProps } from './Review';

const Container = styled.div`
  display: block;
  width: 100%;
  margin: 0 auto;
`;

const SliderContainer = styled.div`
  overflow: hidden;
`;

const slideWidth = 300;
const slideGap = 20;

const Slider = styled.div<{ numberOfReviews: number }>`
  display: grid;
  grid-auto-flow: column;
  gap: ${slideGap}px;
  /* The number elements (twice the number of reviews) * size of a block (slide plus its gap) - 1 gap's width (because in grid gap there is always 1 less gap than item) */
  width: ${(p) => 2 * p.numberOfReviews * (slideWidth + slideGap) - slideGap}px;

  @keyframes marquee {
    0% {
      transform: translateX(0px);
    }
    100% {
      /* transform up to the end of the last review + its gap */
      transform: translateX(-${(p) => p.numberOfReviews * (slideWidth + slideGap)}px);
    }
  }

  /* 5 seconds per [slide + gap] to pass */
  animation: marquee ${(p) => p.numberOfReviews * 5}s linear infinite;
`;

const Slide = styled.div`
  display: block;
  width: ${slideWidth}px;
`;

type Props = { heading: string; summary: SummaryProps; reviews: ReviewProps[] };

export const TrustPilot = ({ summary, reviews, heading }: Props) => {
  return (
    <Container>
      <SectionSidePadding>
        <SectionHeading heading={heading} />
        <Summary {...summary} />
      </SectionSidePadding>

      <SliderContainer>
        <Slider numberOfReviews={reviews.length}>
          <>
            {[...reviews, ...reviews].map((review) => (
              <Slide>
                <Review {...review} />
              </Slide>
            ))}
          </>
        </Slider>
      </SliderContainer>
    </Container>
  );
};
